//Import statements
import Highcharts from 'highcharts';
import highchartsStock from "highcharts/modules/stock";
highchartsStock(Highcharts)
import highchartsExporting from 'highcharts/modules/exporting';
highchartsExporting(Highcharts);
import highchartsExportData from 'highcharts/modules/export-data';
highchartsExportData(Highcharts);
import highchartsAccessibility from 'highcharts/modules/accessibility';
highchartsAccessibility(Highcharts)
import highchartsNoData from "highcharts/modules/no-data-to-display";
highchartsNoData(Highcharts);
import highchartsMore from "highcharts/highcharts-more";
highchartsMore(Highcharts);
import highchartsGauge from "highcharts/modules/solid-gauge";
highchartsGauge(Highcharts);


import Webcomponent from "../common/WebcomponentCreator"
import colors from "./color"
import { fetchTrendData } from './FetchFilterData';
const diagramColors = colors.allColors;

class HighchartsBase extends Webcomponent {
    constructor(template) {
        super(template, { shadowMode: "closed" });
        this.chartOptions = {};
        this.series = [];
        this.categories = [];
        this.colors = diagramColors;
        this.firstColors = [];
        this.loading = false;

        Highcharts.setOptions({
            exporting: {
                url: 'https://highcharts.c.vantetider.se/'
            }
        });

        this.overrideHighchartsMethods();

        Highcharts.SVGRenderer.prototype.symbols.cross = function (x, y, w, h) {
            return ['M', x, y, 'L', x + w, y + h, 'M', x + w, y, 'L', x, y + h, 'z'];
        };
    }

    // Adds the spinner methods to the showLoading/hideLoading methods
    overrideHighchartsMethods() {
        const self = this;
        const originalShowLoading = Highcharts.Chart.prototype.showLoading;
        const originalHideLoading = Highcharts.Chart.prototype.hideLoading;

        Highcharts.Chart.prototype.showLoading = function () {
            originalShowLoading.apply(this, arguments);
            self.showSpinner(this);
        };

        Highcharts.Chart.prototype.hideLoading = function () {
            originalHideLoading.apply(this, arguments);
            self.hideSpinner(this);
        };
    }

    createSpinner(chart) {
        const spinner = document.createElement('spinner-component');
        chart.container.appendChild(spinner);
        chart.spinner = spinner;
    }

    showSpinner(chart) {
        if (!chart.spinner) {
            this.createSpinner(chart);
        }
        chart.spinner.style.display = 'block';
    }

    hideSpinner(chart) {
        if (chart.spinner) {
            chart.spinner.style.display = 'none';
        }
    }

    createEmptyChart(chartDiv, chartOptions) {
        const options = {
            ...chartOptions,
            series: [{
                name: '',
                data: [null]
            }]
        };
        this.chart = new Highcharts.Chart(chartDiv, options);
    }

    showEmptyChart(chartDiv, chartOptions) {
        this.createEmptyChart(chartDiv, chartOptions);
        this.chart.showLoading()
    }

    // Hook method for processing data
    processSeriesData(res) {}

    updateChart(params, url, defaultChartOptions, chartDiv = this.template, seriesObjectName = "series", chartPointMargin = null) {
        //Need loading here to avoid spam clicking
        if (this.loading)
            return;
        this.loading = true;

        if (this.chart) {
            this.chart.showLoading()
        }
        this.getData(params, url, seriesObjectName)
            .then(() => {
                this.setChartOptions(defaultChartOptions);
                if (chartPointMargin || chartPointMargin === 0) {
                    this.chartOptions.chart.height = this.getDynamicHeight(chartPointMargin);
                }
                this.render(chartDiv);

                if (params && params.text) {
                    this.setSubtitle(this.createSubtitleString(params.text));
                }
                this.loading = false;
                this.chart.hideLoading()
            })
            .catch(() => {
                this.loading = false;
                this.chart.hideLoading()
            });
    }

    //Get data and adds it to this.series
    async getData(params, url, seriesObjectName = "series", serieNames = "serieNames", startAt = 0) {
        this.series = [];

        try {
            var res = await fetchTrendData(
                url,
                params.values,
                seriesObjectName);

            this.categories = res.xNames;
            for (let i = startAt; i < res[serieNames].length + startAt; i++) {
                //VERY temporary fix. AvailableHealthcare trend has a spelling error, this is a quick fix to solve it.
                if (res[seriesObjectName][i].name === "Telefontillgänglihet")
                    res[seriesObjectName][i].name = "Telefontillgänglighet";
                //
                let temp = {
                    name: res[seriesObjectName][i].name,
                    data: res[seriesObjectName][i].data,
                    color: this.colors[i],
                    zIndex: i
                }
                this.series.push(temp);

                this.processSeriesData(res);
            }
            if (this.firstColors.length > 0) {
                for (let i = 0; i < this.series.length; i++) {
                    this.series[i].data[0].color = this.firstColors[i];
                }
            }
            return true
        } catch (err) {
            console.error("HighchartsBase.getData() error:", err);
            console.log(err)
            this.errorNoData();
            return false
        }
    }
    render(chartDiv) {
        if (this.chart !== undefined) {
            if (this.chartOptions.xAxis)
                this.chartOptions.xAxis.categories = this.categories;
            this.chart.hideLoading();
            while (this.chart.series.length > 0) {
                this.chart.series[0].remove(true, false);
            }
            this.series.forEach((serie) => {
                this.chart.addSeries(serie, false);
            });

            this.chart.update(this.chartOptions);
        } else {
            if (this.chartOptions.xAxis)
                this.chartOptions.xAxis.categories = this.categories;
            this.chartOptions.series = this.series;
            this.chart = new Highcharts.Chart(chartDiv, this.chartOptions);
        }
        var evt = document.createEvent("HTMLEvents");
        evt.initEvent("resize", false, true);
        window.dispatchEvent(evt);
    }
    getDynamicHeight(setMargin = 0, pointWidth = this.chartOptions.plotOptions ? this.chartOptions.plotOptions.series.pointWidth : 30) {
        let numbCats = 0;
        this.series.forEach(s => {
            if (s.data)
                numbCats += s.data.length;
        })
        const catHeight = pointWidth;
        const margin = setMargin;
        return (catHeight + margin) * numbCats;
    }
    trimUrlParams(params) {
        for (var property in params.values) {
            if (params.values.hasOwnProperty(property)) {
                if (params.values[property] === "-1") {
                    delete params.values[property];
                }
            }
        }
    }
    setChartOptions(options) {
        options = { ...options };
        if (this.series) {
            options.series = this.series;
        }
        else if (this.chartOptions.series) {
            this.series = this.chartOptions.series;
        }

        delete options.lang.loading;
        options.lang.loading = this.spinner;

        this.chartOptions = options;
    }
    addSeries(label, seriesData, enabled, color) {
        this.series.push({ name: label, data: seriesData, visible: enabled, zIndex: enabled ? 1 : 0, color: color });
    }
    addUnnamedSerie(seriesData) {
        this.series.push(seriesData);
    }
    setSubtitle(titleText) {
        if (this.chart != undefined) {
            this.chart.setTitle(null, { text: titleText, align: "left" });
        }
    }
    createSubtitleString(params, options = {
        monthAndYearAsTime: true,
        placeText: "Plats"
    }) {
        //let result = "";
        let { monthAndYearAsTime, placeText } = options;
        var production = ""; //= params.production ? " <b>Status:</b> " + params.production : "";
        if (params.production) {
            production = "<b>" + params.production + "</b>";
            if (params.area)
                production += " <b> - " + params.area + "</b>";
            production += "<br>";
        }
        var indicatorText;
        if (this.chartOptions.title.text) {

            indicatorText = this.chartOptions.title.text;
            this.chartOptions.title.text = null;
            this.chart.update(this.chartOptions);
        }
        const indicator = indicatorText ? "<b>Indikator:</b> " + indicatorText + " " : "";
        const place = params.regions ? "<b>" + placeText + ":</b> " + params.regions : "";
        let time;
        if (monthAndYearAsTime)
            time = (params.month && params.year) ? " <b>Tid:</b>  " + params.month + " " + params.year : " ";
        else
            time = (params.month && params.year) ? " <b>Månad:</b>  " + params.month + " <b>År:</b>  " + params.year : " ";
        const gender = params.gender ? " <b>Kön:</b> " + params.gender : " ";
        const prof = params.profession ? " <b>Yrkesgrupp:</b> " + params.profession : "";
        const careType = params.careType ? " <b>Besöksform:</b> " + params.careType : "";
        const owner = params.management ? " <b>Ägarform:</b> " + params.management : "";
        const unit = params.unit ? " <b>Vårdcentral:</b> " + params.unit : "";
        const hospitalName = params.hospitalName ? " <b>Sjukhus:</b> " + params.hospitalName : "";
        const hospitalType = params.hospitalType ? " <b>Typ:</b> " + params.hospitalType : "";
        const area = params.area ? " <b>Område:</b> " + params.area : "";
        const mvo = params.mvo ? " <b>Specialitet:</b> " + params.mvo : "";
        const service = params.service ? " <b>Vårdutbud:</b> " + params.service : "";
        const ageGroup = params.ageGroup ? " <b>Åldersgrupp:</b> " + params.ageGroup : "";
        const healthcareprovider = params.healthcareprovider ? " <b>Vårdgivare:</b> " + params.healthcareprovider : "";
        const clinic = params.clinic ? " <b>Klinik:</b> " + params.clinic : "";
        
        return production + indicator + place + unit + hospitalName + healthcareprovider + clinic + gender + ageGroup + prof + careType + owner + hospitalType + area + mvo + service + time;
    }
    errorNoData() {
        if (this.chart != undefined) {
            while (this.chart.series.length > 0) {
                this.chart.series[0].remove(true);
            }
            this.chart.hideLoading();
            this.chart.showNoData();
        }
    }
}

export default HighchartsBase;
